import React from 'react';
import { 
  Mail, 
  Phone, 
  MapPin,
  ArrowUp,
  Database,
  Zap,
  Globe
} from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <h3>OnSkip</h3>
              <p>Transforming businesses through multi-platform automation and innovative web solutions.</p>
            </div>
            <div className="footer-contact">
              <div className="contact-item">
                <Mail size={16} />
                <span>hello@onskip.com</span>
              </div>
              <div className="contact-item">
                <Phone size={16} />
                <span>+92 (333) -154-2230</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Remote & On-site Services</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li>
                <a href="https://onskip.com" target="_blank" rel="noopener noreferrer">
                  <Database size={16} />
                  Data & Workflow Automation
                </a>
              </li>
              <li>
                <a href="https://onskip.com" target="_blank" rel="noopener noreferrer">
                  <Zap size={16} />
                  Process Automation
                </a>
              </li>
              <li>
                <a href="https://onskip.com" target="_blank" rel="noopener noreferrer">
                  <Globe size={16} />
                  Web Development
                </a>
              </li>
              <li>
                <a href="https://onskip.com" target="_blank" rel="noopener noreferrer">
                  System Integration
                </a>
              </li>
              <li>
                <a href="https://onskip.com" target="_blank" rel="noopener noreferrer">
                  Custom Solutions
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('about')}>About Us</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')}>Our Work</button>
              </li>
              <li>
                <a href="https://onskip.com" target="_blank" rel="noopener noreferrer">
                  Careers
                </a>
              </li>
              <li>
                <a href="https://onskip.com" target="_blank" rel="noopener noreferrer">
                  Blog
                </a>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')}>Contact</button>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Get Started</h4>
            <p className="footer-cta-text">
              Ready to transform your business with smart automation?
            </p>
            <div className="footer-actions">
              <a 
                href="https://app.smartsheet.com/b/form/819a65d4d35b4bf589f8f0cdd783842c" 
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Free Consultation
              </a>
              <a 
                href="https://app.smartsheet.com/b/form/819a65d4d35b4bf589f8f0cdd783842c" 
                className="btn btn-secondary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Quote
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>&copy; 2024 OnSkip. All rights reserved.</p>
            </div>
            
            <div className="footer-legal">
              <a href="https://onskip.com" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              <a href="https://onskip.com" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </a>
            </div>

            <button className="scroll-to-top" onClick={scrollToTop}>
              <ArrowUp size={20} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
